import React, { Fragment } from "react";
import Pic from "../assets/books.jpg";
import {
  Page,
  Section,
  Box,
  ImageBox,
  HeroBlurb,
  PageContentWrapWithSideBar,
  Heading,
  Text,
  Image
} from "../theme";
import { data } from "../data";

const { Blog } = data;
const BlogPage = props => {
  return (
    <Page>
      <ImageBox useFilter="true" blend="hue" width={1} bgImage={Pic}>
        <HeroBlurb heading="Blog" image={Pic} color="secondaryLight" />
      </ImageBox>
      <PageContentWrapWithSideBar>
        <Section bg="secondaryLight">
          {Blog.map(b => (
            <Box width={1}>
              <Box mx="auto" width={[3 / 4]} maxWidth="768px">
                <Heading maxWidth={900} fontSize={4} pt={5}>
                  {b.title} & Other Things
                </Heading>
                <Text
                  textAlign="left"
                  fontSize={0}
                  textTransform="uppercase"
                  letterSpacing="2px"
                  color="secondaryDark"
                  width={1}
                >
                  by: {b.author}
                </Text>
                <Text textAlign="left" textStyle="dropCap" width={[1]}>
                  {b.content}
                </Text>
                <Text
                  hover="cursor:pointer;"
                  textAlign="left"
                  fontSize={0}
                  textTransform="uppercase"
                  letterSpacing="2px"
                  color="secondaryDark"
                  width={1}
                >
                  Read More...
                </Text>
              </Box>
            </Box>
          ))}
        </Section>
      </PageContentWrapWithSideBar>
    </Page>
  );
};
export default BlogPage;
